import { Dropdown, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ClaimNotesActionMenu.css";
import { useParams } from "react-router-dom";

import { ThreeDots } from "../../../customComponent/ThreeDots";
import { useSelector } from "react-redux";
import { selectCurrentClaimDetails } from "../../../../store/selector";
import { ReactComponent as AlertIcon } from "../../../../assets/svg/alert-icon-popup.svg";
import { StyledMenuItemButton, StyledThreeDotsButton } from "../../../sharedComponents/EditNotesUI";

const { confirm } = Modal;

export const ClaimNotesActionMenu = ({
  note,
  notesList,
  setNotesList,
  noteIndex,
  isVisible,
  onMenuHoverChange,
  onEditNote,
  setHoveredNoteIndex
}) => {
  const { t } = useTranslation();
  const { claimId } = useParams();

  const [isOpen, setIsOpen] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);

  const currentClaimDetails = useSelector(selectCurrentClaimDetails(parseInt(claimId)));
  const isClaimInactive = currentClaimDetails && !currentClaimDetails?.isActive;

  const handleDeleteNote = () => {
    confirm({
      zIndex: 1100,
      centered: true,
      icon: <AlertIcon />,
      title: t("patientRSActions.notes.delete_note_popup_title"),
      content: t("patientRSActions.notes.delete_note_popup_content"),
      cancelText: t("patientRSActions.notes.delete_note"),
      okText: t("patientRSActions.notes.keep_note"),
      onOk: () => {
        onMenuHoverChange(false);
        setHoveredNoteIndex(null);
      },
      onCancel: () => {
        const updateNotesWithDeletedKey = [...notesList].map((note, index) => {
          if (index === noteIndex) {
            note.markAsDeleted = true;
          }
          return note;
        });
        setNotesList(updateNotesWithDeletedKey);
      },
      okButtonProps: {
        id: "keep_note_button"
      },
      cancelButtonProps: {
        id: "delete_note_button"
      }
    });
  };

  const handleEditNote = () => {
    onEditNote?.({ ...note, index: noteIndex });
    setIsOpen(false);
  };

  const dropdownItems = [
    {
      key: "edit",
      label: (
        <StyledMenuItemButton onClick={handleEditNote} type="text" id="note_edit_option" disabled={isClaimInactive}>
          {t("patientApplications.track_tab.edit_note")}
        </StyledMenuItemButton>
      )
    },
    {
      key: "delete",
      label: (
        <StyledMenuItemButton onClick={handleDeleteNote} type="text" id="note_delete_option" disabled={isClaimInactive}>
          {t("patientApplications.track_tab.delete_note")}
        </StyledMenuItemButton>
      )
    }
  ];

  useEffect(() => {
    if (!isVisible && !isMenuHovered) {
      setIsOpen(false);
    }
  }, [isVisible, isMenuHovered]);

  const handleMenuHover = (isHovered) => {
    setIsMenuHovered(isHovered);
    onMenuHoverChange?.(isHovered);
  };

  const handleOpenChange = (visible) => {
    setIsOpen(visible);
  };

  const dropdownRender = (menu) => (
    <div onMouseEnter={() => handleMenuHover(true)} onMouseLeave={() => handleMenuHover(false)}>
      {menu}
    </div>
  );

  return (
    <Dropdown
      menu={{
        items: dropdownItems
      }}
      trigger={["click"]}
      placement="bottomRight"
      open={isVisible && isOpen}
      onOpenChange={handleOpenChange}
      dropdownRender={dropdownRender}
      align={{
        offset: [0, 4],
        overflow: { adjustY: false }
      }}
      onMouseEnter={() => setHoveredNoteIndex(noteIndex)}
      overlayClassName="custom-notes-action-menu"
    >
      <StyledThreeDotsButton type="text" id="note_action_menu">
        <ThreeDots />
      </StyledThreeDotsButton>
    </Dropdown>
  );
};
